import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import fr from 'facet-rest';
import {
  fetchDataFromLinkQueryParam,
  setNewLinkQueryParam,
  useAgentSchedulerDispatchContext,
} from 'Context/NewAgentSchedulerContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import CalendarQuerySelector from '../CalendarQuerySelector';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: '-11vw',
    top: '5vh',
  },
  durationFilter: {
    marginBottom: '20px',
  },
});

const CalendarSidebar = ({
  classes,
  className,
  availabilityResource,
}) => {
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Weekly Calendar Sidebar' });
  const dispatch = useAgentSchedulerDispatchContext();

  const bufferDurationMetaOptions = availabilityResource
    .meta()
    .query(fr.queries.getAvailabilities.name)
    .field('bufferDuration')
    .options()
    .list();

  const meetingDurationMetaOptions = availabilityResource
    .meta()
    .query(fr.queries.getAvailabilities.name)
    .field('duration')
    .options()
    .list();

  const handleSelectMeetingDuration = (option) => {
    const availabilityUrl = new URL(availabilityResource.link('self').url());
    const newAvailabilityQueryParams = new URLSearchParams(availabilityUrl.search);
    newAvailabilityQueryParams.set('duration', option.attr('id'));
    availabilityUrl.search = newAvailabilityQueryParams.toString();
    logEvent('Set Scheduler Calendar meeting length duration', { duration: option.attr('id') });
    setNewLinkQueryParam(dispatch, availabilityUrl.toString());
    fetchDataFromLinkQueryParam(dispatch);
  };

  const handleSelectMeetingBuffer = async (option) => {
    const availabilityUrl = new URL(availabilityResource.link('self').url());
    const newAvailabilityQueryParams = new URLSearchParams(availabilityUrl.search);
    newAvailabilityQueryParams.set('bufferDuration', option.attr('id'));
    availabilityUrl.search = newAvailabilityQueryParams.toString();
    logEvent('Set Scheduler Calendar buffer length duration', { duration: option.attr('id') });
    setNewLinkQueryParam(dispatch, availabilityUrl.toString());
    fetchDataFromLinkQueryParam(dispatch);
  };


  return (
    <div
      {...rootNodeProps}
      className={classNames(classes.root, className)}
    >
      <CalendarQuerySelector
        options={meetingDurationMetaOptions}
        title="Duration"
        selectedQuery={availabilityResource.attr('meetingDuration')}
        onSelectQuery={handleSelectMeetingDuration}
      />
      <CalendarQuerySelector
        options={bufferDurationMetaOptions}
        title="Buffer"
        selectedQuery={availabilityResource.attr('meetingBuffer')}
        onSelectQuery={handleSelectMeetingBuffer}
      />
    </div>
  );
};

CalendarSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  availabilityResource: PropTypes.object.isRequired,
};

CalendarSidebar.defaultProps = {
  className: '',
};

export default withStyles(styles)(CalendarSidebar);
